import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Footer from './components/Footer';
import Contact from './pages/Contact';
import Disclaimer from './pages/Disclaimer';
import Events from './pages/EventsLeagues';
import EventsCalendar from './pages/EventsCalendar';
import EventsDetails from './pages/EventsDetails';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RecentUpdatesDetails from './pages/RecentUpdatesDetails';
import Sports from './pages/Sports';
import SportsDetails from './pages/SportsDetails';
import Team from './pages/Team';
import Preloader from './components/Preloader';
import ScrollToTopButton from './components/ScrollToTopButton';
import EventsSponsors from './pages/EventsSponsors';
import Navigation from './components/Navigation';
import EventsHosted from './pages/EventsHosted';

const App = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <div>
      {loading ? <Preloader /> :


        <Router>
          <Navigation/>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sports" element={<Sports />} />
            <Route path="/events/leagues" element={<Events />} />
            <Route path="/events/hosted-events" element={<EventsHosted />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/events/events-calendar" element={<EventsCalendar />} />
            <Route path="/events/events-sponsors" element={<EventsSponsors/>} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            <Route path="/sports/:SportsName" element={<SportsDetails />} />
            

            <Route path="/events/:EventName" element={<EventsDetails />} />
            <Route path="/recent-events/:RecentEventName" element={<RecentUpdatesDetails />} />

          </Routes>
          <ScrollToTopButton/>
          <Footer />
        </Router>
      }
    </div>

  )
}

export default App